import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'app-double-scroll',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="wrapper1" #wrapper1>
      <div class="div1" #div1></div>
    </div>
    <div class="wrapper2" #wrapper2>
      <div class="div2" #div2>
        <ng-content></ng-content>
      </div>
    </div>
  `,
    styles: [`
    .wrapper1, .wrapper2 {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
    }
    .div1 {
      overflow: hidden;
      height: 0.5px;
    }
    .div2 {
      overflow: hidden;
      min-width: min-content;
    }
  `]})
export class DoubleScrollComponent implements AfterViewInit {
  @ViewChild('wrapper1') wrapper1!: ElementRef<HTMLElement>;
  @ViewChild('wrapper2') wrapper2!: ElementRef<HTMLElement>;
  @ViewChild('div1') div1!: ElementRef<HTMLElement>;
  @ViewChild('div2') div2!: ElementRef<HTMLElement>;

  constructor(
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.cdRef.detach();

    // Set initial width
    this.updateDiv1Width();

    // Set up scroll listeners
    this.setupScrollSync();

    // Handle window resize
    this.renderer.listen('window', 'resize', () => {
      this.updateDiv1Width();
    });
  }

  public updateDiv1Width(): void {
    this.renderer.setStyle(
      this.div1.nativeElement,
      'width',
      `${this.div2.nativeElement.scrollWidth}px`
    );
  }

  private setupScrollSync(): void {
    this.wrapper1.nativeElement.addEventListener('scroll', (e) => {
      this.wrapper2.nativeElement.scrollLeft = (e.target as HTMLElement).scrollLeft;
    });

    this.wrapper2.nativeElement.addEventListener('scroll', (e) => {
      this.wrapper1.nativeElement.scrollLeft = (e.target as HTMLElement).scrollLeft;
    });
  }

  ngAfterViewChecked() {
    this.updateDiv1Width();
  }
}